import { types } from "../constants/types";


export const getServiceType = (data) => ({
    type: types.GET_SERVICETYPE_REQUEST,
    payload:data
});
export const getCountryData = (data) => ({
    type: types.GET_COUNTRY_REQUEST,
    payload:data
});
export const getSuperAdminList = (data) => ({
    type: types.GET_SUPERADMIN_REQUEST,
    payload:data
});